<template>
  <div id="app">
    <router-view />
    <div id="hml" v-if="envType == 'hml'" > 
      HOMOLOGAÇÃO
    </div>
  </div>
</template>

<script>

import env from './config/loadEnv';

export default {
  name: "App",
  data() {
    return {
      envType: 'prod'
    }
  },
  mounted(){
    this.envType = env.envType
  }
};


</script>

<style>

#hml {
    position: fixed; 
    border-style: dashed;
    left: 88%; 
    border-color: yellow;
    top: 90%;
    width: 120px;
    padding: 5px;
    font-weight: bold;
    color: #FFF;
    background-color: rgb(187, 0, 0);
    text-align: center;
    z-index: 1000;
    font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue